export const HOME_CHECK_USER_BEGIN = 'HOME_CHECK_USER_BEGIN';
export const HOME_CHECK_USER_SUCCESS = 'HOME_CHECK_USER_SUCCESS';
export const HOME_CHECK_USER_FAILURE = 'HOME_CHECK_USER_FAILURE';
export const HOME_CHECK_USER_DISMISS_ERROR = 'HOME_CHECK_USER_DISMISS_ERROR';
export const UPDATE_USER_JWT = 'UPDATE_USER_JWT';
